import {_x} from '@wordpress/i18n';
import {useState, useEffect} from '@wordpress/element';

function Ecards({siteUrl}) {
	const [ecards, setEcards] = useState([]);
	const [postTypes, setPostTypes] = useState({});
	const [ecardCategories, setEcardCategories] = useState({});
	const [selectedEcardCategory, setSelectedEcardCategory] = useState({});
	const [totalPosts, setTotalPosts] = useState(null);
	const [totalPages, setTotalPages] = useState(null);
	const [nextPage, setNextPage] = useState(null);
	const [selectedPostType, setSelectedPostType] = useState(null);
	const [isFirstLoad, setIsFirstLoad] = useState(true);
	const [isFirstLoadError, setIsFirstLoadError] = useState(true);
	const [isLoadingEcards, setIsLoadingEcards] = useState(true);
	const [isLoadingEcardsError, setIsLoadingEcardsError] = useState(true);
	const [isLoadingMoreEcards, setIsLoadingMoreEcards] = useState(false);
	const [isLoadingMoreEcardsError, setIsLoadingMoreEcardsError] = useState(false);

	/**
	 * Initial Fetch of all data, Categories and all the posts from page 1 (not filtered)
	 */
	useEffect(() => {
		fetch(`${siteUrl}/wp-json/zeitpress/v1/shop-ecards?page=1`)
			.then((response) => {
				if (!response.ok) {
					throw new Error("Failed to fetch ecards");
				}
				return response.json();
			})
			.then((data) => {
				console.log('data', data);
				setEcards(data.ecards);
				setPostTypes(data.post_types);
				setEcardCategories(data.ecard_categories);
				setTotalPages(data.total_pages);
				setTotalPosts(data.total_posts);
				setNextPage(data.next_page);
				setIsFirstLoad(false);
				setIsLoadingEcards(false);
			})
			.catch((error) => {
				setIsFirstLoadError(error.message);
				setIsLoadingEcardsError(error.message);
			})
			.finally(() => {
				setIsFirstLoadError(false);
				setIsLoadingEcardsError(false);
			});
	}, [siteUrl]);

	// Handler for when the select value changes
	const handleSelectEcardCategoryChange = (event) => {
		setSelectedEcardCategory(event.target.value);
	};

	const handleFilterEcardCat = (postType) => {

		event.preventDefault();  // Prevent the default form submission
		console.log('Selected Category ID:', selectedEcardCategory);

		setIsLoadingEcards(true);
		setSelectedPostType(postType);
		fetch(`${siteUrl}/wp-json/zeitpress/v1/shop-ecards?page=1${selectedEcardCategory ? `&ecard_cat=${selectedEcardCategory}` : 0}`)
			.then((response) => {
				if (!response.ok) {
					throw new Error("Failed to fetch ecards");
				}
				return response.json();
			})
			.then((data) => {
				setEcards(data.ecards);
				setIsLoadingEcards(false);
				setTotalPosts(data.ecards);
				setTotalPages(data.total_pages);
				setNextPage(data.next_page);
			})
			.catch((error) => {
				setIsLoadingEcardsError(error.message);
			})
			.finally(() => {
				setIsLoadingEcards(false);
			});
	};

	const loadNextPage = () => {
		setIsLoadingMoreEcards(true)
		fetch(`${siteUrl}/wp-json/zeitpress/v1/shop-ecards?page=${nextPage}${selectedPostType ? `&post_type=${selectedPostType}` : ''}`)
			.then((response) => {
				if (!response.ok) {
					throw new Error("Failed to fetch ecards");
				}
				return response.json();
			})
			.then((data) => {
				setEcards([...ecards, ...data.ecards]);
				setNextPage(data.next_page);
			})
			.catch((error) => {
				setIsLoadingEcardsError(error.message);
				setIsLoadingMoreEcardsError(error.message);
				setIsLoadingMoreEcards(false);
			})
			.finally(() => {
				setIsLoadingMoreEcards(false);
			});
	};

	const decodeHtml = (html) => {
		var txt = document.createElement("textarea");
		txt.innerHTML = html;
		return txt.value;
	}

	return (
		<div className="zp4-shop-ecards">
			<div className="layout-container">
				{isFirstLoad ? (
					<>
						<span className="screen-reader-text">{`Loading Filters`}</span>
						<div class="lds-grid">
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
						</div>
					</>
				) : (
					<div className="shop-ecards-filters-container" style={{display: 'none'}}>
						<form className="shop-ecards-filters">
							<label for="ecard_category">{_x('Filter By:', 'Block - Shop Ecards', 'shop-ecards')}</label>
							<div className="select-button-wrapper">
								<div className="select-wrapper">
									<select id="ecard_category" name="ecard-cat" value={selectedEcardCategory}
											onChange={handleSelectEcardCategoryChange}>
										<option value={0}>All Holidays/occasions</option>
										{Object.entries(ecardCategories).map(([key, value]) => (
											<option value={value.term_id} key={key}>{value.name}</option>
										))}
									</select>
								</div>
								<button id="filter_ecards_cat_submit" type="submit"
										onClick={() => handleFilterEcardCat()}
										className="wp-block-button__link wp-element-button">{_x('Apply Filter', 'Block - Shop Ecards', 'shop-ecards')}
								</button>
							</div>
						</form>
					</div>
				)}
				<div className="zp4-product-list-content">
					{isLoadingEcards && !isFirstLoad ? (
						<>
							<span className="screen-reader-text">{`Loading E-Cards`}</span>
							<div class="lds-grid">
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
								<div></div>
							</div>
						</>
					) : (
						<ol className="zp4-product-list-cards" aria-live="assertive" aria-label={`E-Cards List`}>
							{ecards.map(
								({permalink, title, short_description, featured_image, id}) => (
									<li className="zp4-product-list-card" key={id}>
										{featured_image && (
											<div class="image-container"
												 dangerouslySetInnerHTML={{
													 __html: featured_image,
												 }}
											/>
										)}

										<div className="zp4-product-list-card-content">
											{permalink && title && (
												<a href={permalink}>{title && <h2>{decodeHtml(title)}</h2>}</a>
											)}

											{short_description && (
												<p
													dangerouslySetInnerHTML={{
														__html: short_description,
													}}
												/>
											)}
										</div>
									</li>
								)
							)}
						</ol>
					)}
					{isLoadingMoreEcards ? (
						<div className="wp-block-buttons is-layout-flex">
							<div className="wp-block-button is-style-outline has-custom-font-size has-medium-font-size">
								<button
									className="wp-block-button__link wp-element-button">{_x('Loading more ecards', 'Block - Shop Ecards', 'shop-ecards')}...
								</button>
							</div>
						</div>
					) : isLoadingMoreEcardsError ? (
						_x('An error occurred while fetching more ecards.', 'Block - Shop Ecards', 'shop-ecards')
					) : !isLoadingEcards && nextPage !== null && nextPage <= totalPages ? (
						<div className="wp-block-buttons is-layout-flex">
							<div className="wp-block-button is-style-outline has-custom-font-size has-medium-font-size">
								<button className="wp-block-button__link wp-element-button"
										onClick={loadNextPage}>{_x('Load More', 'Block - Shop Ecards', 'shop-ecards')}
								</button>
							</div>
						</div>
					) : (
						!isLoadingEcards && nextPage >= totalPages &&
						_x('No more ecards.', 'Block - Shop Ecards', 'shop-ecards')
					)}
				</div>
			</div>
		</div>
	);
}

export default Ecards;
